import { compose, mdsWidget } from 'dojo/_base/declare';
import _ControlBase from '../_ControlBase/_ControlBase';
import Tooltip from '../Floating/Tooltip';
import { TranslationHelpers } from "../../../more/Helpers";

class _StatefulBase extends compose(_ControlBase) {

    isReadonly: boolean = false;
    isVisible: boolean = true;
    isNonInteractive: boolean = false;
    protected highlightOnEmptyValue: boolean = false;
    protected _manualHighlightOverride: boolean = false;
    isMandatory: boolean = false; // genau gleiche Eigenschaft wie Highlight, aber weils ja keine modernen getter und setter gibt ....
    


    //validierung
    validationEnabled: boolean = false;
    validationMsgNodeContainer: string = "errorMsgNode";
    validationErrorMsgText: string = null;// this.translate('Generic__mandatory');//"Invalid Data"
    isValid: boolean = false;
    dirtyInput: any;

    private lockInfo: HTMLElement;

    // Methods
    /**
    * Funktion, die dem Endbenutzer Informationen darüber gibt, warum er bestimmte Eingaben nicht bearbeiten kann.
    * Standardmäßig wird readOnly einer Eingabe auf true gesetzt.
    * @param msg Textnachricht – z. B. "unzureichende Berechtigungen"
    * @param enable Optional: enables/disables lockInfo. Wenn 'false', destroy vorhandene lockInfo. Standart enable = true
    * @param forceReadOnly Optional: definiert, ob die Funktion mit der readOnly-Einstellung interferieren soll. Standard forceReadOnly = true
    */
    enableLockInfo(msg: string, enable: boolean = true, forceReadOnly:boolean = true) {

        if (forceReadOnly) this.setReadonly(enable);
        if (this.lockInfo) this.UiModder.domConstruct.destroy(this.lockInfo);
        if (!enable) return;

        this.lockInfo = this.createFontawesomeIcon("fas fa-lock marginSmall round hoverTxtPrimary", null, null);
        let tooltip = new Tooltip();
        tooltip.setup({
            content: msg,
            targetnode: this.lockInfo,
            delayMS: 200
        });
        let node = null;
        let isCheckbox = false;

        // FIND LABEL
        if (this.domNode.firstElementChild?.nodeName == "LABEL") {
            node = this.domNode.firstElementChild;

        } else if (this.domNode.previousElementSibling?.nodeName == "LABEL") {
            node = this.domNode.previousElementSibling;

        } else {

            let count = this.domNode.children.length;
            for (var i = 0; i < count; i++) {
                let child = this.domNode.children.item(i)
                if (child?.nodeName == "LABEL") node = child;
                else if (child.className.indexOf("CheckBox") != -1) isCheckbox = true;
            }
        }

        // FIND LABEL IN CHECKBOX
        if (isCheckbox) {
            let inputContainer = this.domNode.children.item(0).children.item(1);
            let side = null;

            if (inputContainer.className.indexOf("right") != -1) side = "right";
            if (inputContainer.className.indexOf("left") != -1) side = "left";

            if (side) {

                let count = inputContainer.children.length;
                for (var i = 0; i < count; i++) {
                    let child = inputContainer.children.item(i)
                    if (child?.nodeName == "LABEL" && child.className.indexOf(side) != -1) {
                        node = child;
                        this.UiModder.domStyle.set(this.lockInfo, "align-self", "center");
                        break;
                    }
                }
            }
        }

        // FALLBACK
        if (node == null) {
            node = this.domNode;
            this.UiModder.domStyle.set(this.lockInfo, "align-self", "center");
        }

        // SET AND PLACE
        this.UiModder.domStyle.set(this.lockInfo, "pointer-events", "all");
        this.UiModder.domConstruct.place(this.lockInfo, node, "before");
    }

    validateInput(): boolean {

        //console.debug("stateful - validateInput - enabled?", this.validationEnabled, validationData);

        let previousValid = this.isValid;

        if (this.validationEnabled) {
            let validationResult = this.customValidation(this._value);

            if (validationResult === true || validationResult === false) {
                this.isValid = validationResult;
                this.setValidationErrorMsgText("");
            } else {
                this.isValid = false;
                if (typeof (validationResult) == "string") {
                    validationResult = TranslationHelpers.tryTranslate(validationResult, true);
                    this.setValidationErrorMsgText(validationResult);
                }
            }

            this._setValidationResultStyle();

            if (previousValid != this.isValid) this.emit("valid", this.isValid);

            if (!this.isValid) {
                
                return false;
            } else {

                return true;
            }

        } else {
            this.isValid = true;

            if (previousValid != this.isValid) this.emit("valid", this.isValid);

            this._setValidationResultStyle();
            //console.log("validation is not enabled")
            return true;
        }
    }

    protected customValidation(value?): boolean | string {
        // hier die individuelle Validierungsoperation
        // in der KindKlasse ausprogrammieren

        // Beispiel (default):
        let result: boolean = false;

        if (this.isMandatory != true) {
            result = true;
        }

        else if (typeof (this._value?.length) == "number") {
            result = this._value.length > 0;
        }
        else if (this._value != "" && this._value != null && typeof (this._value) != "undefined") {
            result = true;
        }
        return result;
    }

    protected getDirtyValue(): any {
        // return the inputNode.value in der kinderklasse
    }

    forceHighlight(bHighlight?: boolean) {
        //console.debug("edit forceHighlight?", bHighlight);
        this._manualHighlightOverride = bHighlight !== false;
        this._setValidationResultStyle();
    }


    protected _insertValidationMsgErrorNode(text: string): void {

        if (text) {
            //this.UiModder.domStyle.set(this[this.validationMsgNodeContainer], "position", "relative");
            let node = this.UiModder.domConstruct.create("div", {
                "class": "moreCore_ValidationMsgError",
                //"innerHTML": '<i class="fa fa-exclamation-circle" aria-hidden="true">'
            }, this[this.validationMsgNodeContainer]);

            if (text) this.UiModder.domAttr.set(node, "title", text);
        }
        this.UiModder.domClass.toggle(this[this.validationMsgNodeContainer], "show", !!text);

    }

    protected _onBlur(evt?) {
        super._onBlur.apply(this, arguments as any);

        //console.debug(this.id + " _onBlur - timeouthandle waiting?", !!this.valueChangeTimeoutHandle);
        if (this._afterBlur) {
            try {
                this._afterBlur(this._valueEmitted, this._value);
            } catch (ex) {

            }
        }

        //this.emit("blur");
        if (this._valueEmitted == this._value) return; // nichts passiert, wenn der Wert schon emittet worden ist

        if (this.valueChangeTimeoutHandle) {
            this.emitChangeEvent();
            clearTimeout(this.valueChangeTimeoutHandle);
            this.valueChangeTimeoutHandle = null;
            }

    }

    protected _afterBlur(emittedValue: any, currentValue: any) {

    }
    

    setValue(newValue: any, suppressChangeEvent: boolean = false): void {
        this._value = newValue;
        this.setInputValue(newValue, suppressChangeEvent);

        this.validateInput();

        if (suppressChangeEvent === true) {
            this._valueEmitted = this._value;
        }
        else {
            this.__delayValueChangeEmit();
        }    
    }


    protected setInputValue(value?: any, suppressChangeEvent?: boolean): void {
        // wird in kindklasse ausprogrammiert
    }

    getValue(): any {
        if (!this.isValid) return null;

        if (typeof (this._value) == "number") {
            return this._value;
        }
        if (typeof (this._value) == "boolean") {
            return this._value;
        }
        if (this._value) {
            return this._value
        }
        return null;
    }

    protected _setReadonlyStyle(): void {
        // wird in kindklasse ausprogrammiert
    }

     protected _setNonInteractiveStyle(): void {
        // wird in kindklasse ausprogrammiert
    }

    
    setReadonly(bReadOnly: boolean): void {
        this.isReadonly = bReadOnly;
        this._setReadonlyStyle();

        this.UiModder.domClass.toggle(this.domNode, "readonly", this.isReadonly === true);
    }
    /**
     * Das Control Nicht-Interaktiv machen. Dadurch wird das Control nicht "abgeblendet" wie bei Readonly, ist aber nicht anklickbar.
     * @param bNotInteractive
     */
    setNonInteractive(bNotInteractive: boolean = true) {
        this.isNonInteractive = bNotInteractive === true;

        this.UiModder.domClass.toggle(this.domNode, "noInteraction", this.isNonInteractive);

        this._setNonInteractiveStyle();
    }

    getReadonly(): boolean {
        return this.isReadonly;
    }

    protected _setVisibleStyle(): void {
        this.isVisible ? this.UiModder.domClass.add(this.domNode, "w3-hide") : this.UiModder.domClass.remove(this.domNode, "w3-hide");
    }

    setVisible(visible: boolean = true): void {
        this.isVisible = visible;
        this._setVisibleStyle();
    }

    getVisible(): boolean {
        return this.isVisible;
    }

    setMandatory(bMandatory: boolean = true) {
        this.highlightOnEmptyValue = bMandatory == true;
        this.isMandatory = this.highlightOnEmptyValue;
        this.setValidationEnabled(bMandatory);
        this.validateInput();
    }

    getMandatory():boolean {
        return this.isMandatory;
    }

    setCustomValidation(fct: (value: any) => boolean | string) {
        if (fct) {
            this.customValidation = fct;
            this.setValidationEnabled(true);
            this.validateInput();
        }
    }

    setValidationEnabled(bEnable?: boolean) {
        this.validationEnabled = bEnable !== false;
        //this.validateInput();

        if (this.validationEnabled != true) {
            this._setValidationResultStyle();
        }
    }


    protected _setValidationResultStyle(): void {
        try {
            this.UiModder.domClass.remove(this.domNode, "invalid");

            if (!this.isValid && this.validationEnabled === true) {
                this.UiModder.domClass.add(this.domNode, "invalid");
            }
        } catch (ex) {

        }


        if (this[this.validationMsgNodeContainer]) {
            // wird in kindklasse ausprogrammiert

            this.UiModder.domConstruct.empty(this[this.validationMsgNodeContainer]);
            this.UiModder.domClass.remove(this[this.validationMsgNodeContainer], "show");

            if (!this.isValid) {
                this._insertValidationMsgErrorNode(this.validationErrorMsgText);
            }
        }

    }

    setValidationErrorMsgText(text:string): void {
        this.validationErrorMsgText = text;
    }


    // dojo-Setter und Getter

    _setValidationErrorMsgTextAttr(text: string): void {
        this.setValidationErrorMsgText(text);
    }

    _setValidationEnabledAttr(value: boolean):void {
        this.setValidationEnabled(value);
    }

    _setVisibleAttr(visible: boolean): void {
        this.setVisible(visible);
    }

    _getVisibleAttr(): boolean {
        return this.isVisible;
    }

    _setValueAttr(newValue: any): void {
        this.setValue(newValue);
    }

    _getValueAttr(something?: any): any {
        return this.getValue();
    }

    _setMandatoryAttr(value: boolean): void {
        this.setMandatory(value === true);
    }

    private _setIsMandatoryAttr(value: boolean): void {
        this.setMandatory(value);
    }

    _getMandatoryAttr(value: boolean): void {
        this.setMandatory(value === true);
    }

    protected _setIsReadonlyAttr(value: boolean): void {

        this.setReadonly(value);
    }

    protected _setReadOnlyAttr(value: boolean) {
        this.setReadonly(value);
    }
    _setReadonlyAttr(readonly: boolean): void {
        this.setReadonly(readonly);
    }

    private _setNonInteractiveAttr(value: boolean): void {

        this.setNonInteractive(value);
    }

    _getReadonlyAttr(): boolean {
        return this.getReadonly();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.isValid = !this.isMandatory;
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(_StatefulBase);